import React, {Component} from "react"
import {ComposableMap, Geographies, Geography, ZoomableGroup,} from "react-simple-maps"
import {scaleLinear} from "d3-scale"
import {withRouter} from "react-router";
import * as classes from './BasicMap.css';

const popScale = scaleLinear()
    .domain([0, 10000, 50000, 100000])
    .range(["#fff", "#4fc24a", "#366D2E", "#034400"]);

class BasicMap extends Component {

    state = {
        tooltipPosition: {
            left: 100,
            top: 0
        },
        tooltipDisplay: 'none',
        countryCovered: {
            name: "",
            totalDrugs: 0
        },
        continents: {}
    };

    componentDidMount = () => {
        const json = require('./world');
        json.objects.units.geometries.forEach(geo => {
            this.countContinents(geo);
        });
        this.props.shareContinentsInfo(this.state.continents);
    };

    handleClick = region => {
        const countryCode = region.properties.iso_a2;
        if (this.props.drugsPerCountry[countryCode]) {
            this.props.history.push("countries/" + countryCode);
        } else if (this.props.drugsPerCountry[region.properties.iso_a3]) {
            this.props.history.push("countries/" + region.properties.iso_a3);
        }
    };

    getValue = (iso2, iso3) => {
        let value = 0;
        if (this.props.drugsPerCountry) {
            if (this.props.drugsPerCountry[iso2]) {
                value = this.props.drugsPerCountry[iso2];
            } else if (this.props.drugsPerCountry[iso3]) {
                value = this.props.drugsPerCountry[iso3];
            }
        }
        return popScale(value);
    };

    getHoverColor = (iso2, iso3) => {
        const countries = this.props.drugsPerCountry;
        if (countries[iso2] || countries[iso3]) {
            return "#30752e";
        }
        return "#fff";
    };

    onMouseEnter = e => {
        const drugsPerCountry = this.props.drugsPerCountry;
        if (drugsPerCountry[e.properties.iso_a2]) {
            const countryCovered = {
                name: e.properties.brk_name,
                totalDrugs: drugsPerCountry[e.properties.iso_a2]
            };
            this.setState({tooltipDisplay: 'flex', countryCovered})
        } else if (drugsPerCountry[e.properties.iso_a3]) {
            const countryCovered = {
                name: e.properties.brk_name,
                totalDrugs: drugsPerCountry[e.properties.iso_a3]
            };
            this.setState({tooltipDisplay: 'flex', countryCovered})
        } else {
            this.setState({tooltipDisplay: 'none'})
        }
    };

    _onMouseMove = e => {
        const tooltipPosition = {
            top: e.screenY - 250,
            left: e.screenX - 550
        };
        this.setState({tooltipPosition});
    };

    _onMouseOut = () => {

        this.setState({tooltipDisplay: 'none'})
    };

    renderTooltip() {
        const top = this.state.tooltipPosition.top;
        const left = this.state.tooltipPosition.left;
        const display = this.state.tooltipDisplay;
        return (
            <div style={{left: left + "px", top: top + "px", position: 'absolute', display: display}}
                 className={classes.tooltip}>
                <div className={classes.bold}>{this.state.countryCovered.name}</div>
                <div>Total drugs: <span className={classes.bold}>{this.state.countryCovered.totalDrugs}</span></div>
            </div>
        )
    };

    countContinents = (geo) => {
        const continents = this.state.continents;
        const drugsPerCountry = this.props.drugsPerCountry;
        if (drugsPerCountry[geo.properties.iso_a2]) {
            if (continents[geo.properties.continent]) {
                let countryCount = continents[geo.properties.continent];
                continents[geo.properties.continent] = countryCount + 1;
            } else {
                continents[geo.properties.continent] = 1;
            }
            this.setState({continents});
        } else if (drugsPerCountry[geo.properties.iso_a3]) {
            if (continents[geo.properties.continent]) {
                let countryCount = continents[geo.properties.continent];
                continents[geo.properties.continent] = countryCount + 1;
            } else {
                continents[geo.properties.continent] = 1;
            }
            this.setState({continents});
        }
    };

    render() {
        return (
            <div className={"ibox"} onMouseMove={this._onMouseMove} onMouseOut={this._onMouseOut}>
                <div className="ibox-content">
                    <ComposableMap
                        projectionConfig={{
                            scale: 205,
                            rotation: [-11, 0, 0],
                        }}
                        width={980}
                        height={638}
                        style={{
                            width: "100%",
                            height: "auto",
                        }}
                    >
                        <ZoomableGroup center={[0, 20]}>
                            <Geographies geography={require("./world")}>
                                {(geographies, projection) => geographies.map((geography, i) => {
                                    return (
                                        <Geography
                                            onMouseEnter={this.onMouseEnter}
                                            key={i}
                                            geography={geography}
                                            projection={projection}
                                            onClick={this.handleClick}
                                            style={{
                                                default: {
                                                    fill: this.getValue(geography.properties.iso_a2, geography.properties.iso_a3),
                                                    stroke: "#607D8B",
                                                    strokeWidth: 0.75,
                                                    outline: 'none',
                                                },
                                                hover: {
                                                    fill: this.getHoverColor(geography.properties.iso_a2, geography.properties.iso_a3),
                                                    stroke: "#607D8B",
                                                    strokeWidth: 0.75,
                                                    outline: "none",
                                                    cursor: 'pointer'
                                                },
                                                pressed: {
                                                    fill: this.getHoverColor(geography.properties.iso_a2, geography.properties.iso_a3),
                                                    stroke: "#607D8B",
                                                    strokeWidth: 0.75,
                                                    outline: "none",
                                                }
                                            }}
                                        />
                                    )
                                })}
                            </Geographies>
                        </ZoomableGroup>
                    </ComposableMap>
                </div>
                {
                    this.renderTooltip()
                }
            </div>
        )
    }
}

export default withRouter(BasicMap);
